<template>
  <v-app>
    <Navbar v-if="showNav" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from '@/components/UI/Navbar.vue';

const route = useRoute();

const showNav = computed(() => route.name !== 'Login');
</script>

<style lang="scss">
@import './styles/app.scss';
</style>
